import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { StaticPageSeo } from '@app/components/core/seo/StaticPageSeo'
import { pages } from '@app/util/links'

export const Events = () => {
  const t = useTranslations().app.eventsPage
  return (
    <PageLayout>
      <StaticPageSeo
        path={pages.events}
        pageTitle={t.title}
        description={t.description}
      />
      <Title.H1>{t.title}</Title.H1>
    </PageLayout>
  )
}
